import React from 'react';
import {MAX_FILE_SIZE} from "../../../../config/defaults";

export const DropzoneWrapper = ({children,accept="*",maxSize=MAX_FILE_SIZE,maxFiles=1,setFile}) => {

    return <div>{children}</div>;
};